import { publicClient } from '../utils/chain-client';
import { useWallet } from './use-wallet';
import { useQuery } from '@tanstack/react-query';
import { Address, erc20Abi } from 'viem';

export const useSignedAllowance = (tokenAddress?: string, marketAddress?: string) => {
  const { wallet } = useWallet();
  const ownerAddress = wallet?.address;
  return useQuery({
    enabled: Boolean(ownerAddress) && Boolean(tokenAddress) && Boolean(marketAddress),
    queryKey: ['allowance', tokenAddress, ownerAddress, marketAddress],
    queryFn: async () =>
      publicClient.readContract({
        address: tokenAddress as Address,
        abi: erc20Abi,
        functionName: 'allowance',
        args: [ownerAddress as Address, marketAddress as Address],
      }),
  });
};
